// extracted by mini-css-extract-plugin
export default {"summaryTab":"SummaryOP_summaryTab__4FXRg","summaryPreview":"SummaryOP_summaryPreview__8Ml4s","shareModal":"SummaryOP_shareModal__ooaYh"};